export const SET_EMAIL_TEMPLATE = 'SET_EMAIL_TEMPLATE';
